// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountV2SitesHubGetSitesHubGetSitesResponse {
    static getAttributeTypeMap() {
        return AccountV2SitesHubGetSitesHubGetSitesResponse.attributeTypeMap;
    }
}
AccountV2SitesHubGetSitesHubGetSitesResponse.discriminator = undefined;
AccountV2SitesHubGetSitesHubGetSitesResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<SiteModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=accountV2SitesHubGetSitesHubGetSitesResponse.js.map